var _rect, _rect2, _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_244_33466",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_244_33466)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.6667H24V5.33334H0V10.6667Z",
    fill: "#17508F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.33333H24V0H0V5.33333Z",
    fill: "#E1444D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14307 8.00001C5.14307 7.50767 5.41119 6.43857 5.58012 5.81389C5.65736 5.52824 5.91777 5.33334 6.21369 5.33334H8.64512C8.94044 5.33334 9.20047 5.52742 9.27799 5.81239C9.44694 6.43345 9.71449 7.49647 9.71449 8.00001C9.71449 8.58227 9.30517 10.0891 9.17939 10.5384C9.1556 10.6234 9.1149 10.7021 9.05594 10.7678C8.81701 11.0338 8.1229 11.7333 7.42878 11.7333C6.73417 11.7333 6.03956 11.0328 5.80111 10.7672C5.74252 10.7019 5.70193 10.6237 5.67812 10.5392C5.55227 10.0931 5.14307 8.5967 5.14307 8.00001Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_244_33466",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 5,
    height: 7
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14307 8.00001C5.14307 7.50767 5.41119 6.43857 5.58012 5.81389C5.65736 5.52824 5.91777 5.33334 6.21369 5.33334H8.64512C8.94044 5.33334 9.20047 5.52742 9.27799 5.81239C9.44694 6.43345 9.71449 7.49647 9.71449 8.00001C9.71449 8.58227 9.30517 10.0891 9.17939 10.5384C9.1556 10.6234 9.1149 10.7021 9.05594 10.7678C8.81701 11.0338 8.1229 11.7333 7.42878 11.7333C6.73417 11.7333 6.03956 11.0328 5.80111 10.7672C5.74252 10.7019 5.70193 10.6237 5.67812 10.5392C5.55227 10.0931 5.14307 8.5967 5.14307 8.00001Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_244_33466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.71463 5.86668L5.14321 11.2",
    stroke: "#E1444D",
    strokeWidth: 1.33333,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14328 5.86668L9.7147 11.2",
    stroke: "#E1444D",
    strokeWidth: 1.33333,
    strokeLinecap: "square"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRs);
export default __webpack_public_path__ + "static/media/RS.a86b8faff970bbd789aa7e54e9d31ab5.svg";
export { ForwardRef as ReactComponent };